<template>
	<div class="mainPage">
		<div class="mainBoxTop flex_start">
			<div class="welcomeTxt">欢迎，admin！</div>
			<div class="rightStatistics flex_end">
				<div class="statisticsBox flex_start" v-if="incomeForm.isPlatform" @click="companyManage">
					<img src="../../assets/images/homeCompany.png" alt="" />
					<div>
						<div class="statisticsNum" >{{incomeForm.companyTotal}}</div>
						<div class="statisticsTxt">合作公司（家）</div>
					</div>
					<div class="splitLine"></div>
				</div>
				<div class="statisticsBox flex_start" @click="applicationManage">
					<img src="../../assets/images/homeApp.png" alt="" />
					<div>
						<div class="statisticsNum">{{incomeForm.appTotal}}</div>
						<div class="statisticsTxt">APP应用（个）</div>
					</div>
					<div class="splitLine" v-if="!incomeForm.isPlatform"></div>
				</div>
				<div class="statisticsBox flex_start" v-if="!incomeForm.isPlatform">
					<img src="../../assets/images/homeAds.png" alt="" />
					<div>
						<div class="statisticsNum">{{incomeForm.adTotal}}</div>
						<div class="statisticsTxt">广告单元（个）</div>
					</div>
				</div>
			</div>
		</div>
		<div class="incomeList space_between">
			<div class="incomeBox space_between">
				<div class="incomeCont">
					<div class="incomeTxt">昨日预估收益</div>
					<div class="incomeNum">¥{{incomeForm.yeIncome}}</div>
				</div>
				<img src="../../assets/images/homeIncome1.png" alt="" />
			</div>
			<div class="incomeBox space_between">
				<div class="incomeCont">
					<div class="incomeTxt">前7日预估收益</div>
					<div class="incomeNum">¥{{incomeForm.weekIncome}}</div>
				</div>
				<img src="../../assets/images/homeIncome2.png" alt="" />
			</div>
			<div class="incomeBox space_between">
				<div class="incomeCont">
					<div class="incomeTxt">本月预估收益</div>
					<div class="incomeNum">¥{{incomeForm.monIncome}}</div>
				</div>
				<img src="../../assets/images/homeIncome3.png" alt="" />
			</div>
			<div class="incomeBox space_between">
				<div class="incomeCont">
					<div class="incomeTxt">总预估收益</div>
					<div class="incomeNum">¥{{incomeForm.allIncome}}</div>
				</div>
				<img src="../../assets/images/homeIncome4.png" alt="" />
			</div>
		</div>
		<div class="chartsBox">
			<div class="chartsRow flex_start">
				<div class="chartPrimary flex_start">
					<div class="chartsTips">数据趋势</div>
					<el-select class="homeCompanySelect" v-model="queryData.companyId" filterable size="small" @change="companyOptionsChange">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="chartControls flex_start">
					<el-radio-group class="homeDataType" v-model="incomeRadioCheck" @change="checkboxFun">
						<el-radio :label="1">收益</el-radio>
						<el-radio :label="2">展现</el-radio>
						<el-radio :label="3">点击</el-radio>
						<el-radio :label="4">eCPM</el-radio>
					</el-radio-group>
					<el-date-picker class="homeDatePicker" v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="dateChange" :clearable="false">
					</el-date-picker>
				</div>
			</div>
			<div class="" id="lineChart"></div>
		</div>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	export default {
		data() {
			return {
				queryData: {
					companyId: '',
				},
				incomeRadioCheck: 1,
				chartName: '收益',
				companyOptions: [],
				datePicker: [],
				
				lineChartsXData: [],
				lineChartsYData1: [],
				lineChartsYData2: [],
				lineChartsYData3: [],
				lineChartsYData4: [],
				lineChartsYDataChecked: [],
				incomeForm: {},
			}
		},
		activated(){
			this.dateInit();
			this.getIncomeData();
		},
		mounted() {
			this.getCompanyOption();
			// this.drawLineCharts();
		},
		methods: {
			// 日期选择器初始化
			dateInit() {
				let endDate = new Date();
				endDate.setDate(endDate.getDate() - 1);      // 昨天（不包含今天）
				let startDate = new Date(endDate);           // 基于结束日期创建副本，避免跨月时月份错误
				startDate.setDate(startDate.getDate() - 6);  // 再向前推6天，共7天范围

				const formatDate = (date) => {
					return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
				};
				this.datePicker = [formatDate(startDate), formatDate(endDate)];
			},
			async getIncomeData(){
				let res = await this.$http.post(this.$api.common.homeIncome);
				this.incomeForm = res.data
			},
			checkboxFun(val) {
			  if(val == 1){
					this.lineChartsYDataChecked = JSON.parse(JSON.stringify(this.lineChartsYData1))
					this.chartName = '收益'
				}else if(val == 2){
					this.lineChartsYDataChecked = JSON.parse(JSON.stringify(this.lineChartsYData2))
					this.chartName = '展现'
				}else if(val == 3){
					this.lineChartsYDataChecked = JSON.parse(JSON.stringify(this.lineChartsYData3))
					this.chartName = '点击'
				}else if(val == 4){
					this.lineChartsYDataChecked = JSON.parse(JSON.stringify(this.lineChartsYData4))
					this.chartName = 'eCPM'
				}
				this.drawLineCharts();
			},
			companyOptionsChange(){
				this.lineChartsYDataChecked = []
				this.getChartData();
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
				let obj = {
					label: '全部',
					value: -1,
					icon: null
				}
				this.companyOptions.unshift(obj);
				if(res.data&&res.data.length>0){
					this.queryData.companyId = this.companyOptions[0].value
					this.getChartData();
				}
			},
			companyManage(){
				this.$router.push({
					path: '/companyManage/companyManage',
					query: {
						sideId: 2
					}
				})
			},
			applicationManage() {
				this.$router.push({
					path: '/aggregation/applicationManage',
					query: {
						sideId: 32
					}
				})
			},
			drawLineCharts() {
				let chartDom = document.getElementById('lineChart');
				// 1. 销毁旧实例（如果存在）
				if (echarts.getInstanceByDom(chartDom)) {
					echarts.dispose(chartDom);
				}
				let myChart = echarts.init(chartDom);
				let option = {
					// legend: {
					// 	top: '2%'
					// },
					grid: {
						bottom: '5%',
						right: '2%',
						left: '2%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						// showContent: false
					},
					xAxis: [{
						type: 'category',
						// data: ['2023-06-03', '2023-06-04', '2023-06-05', '2023-06-06', '2023-06-07', '2023-06-08',
						// 	'2023-06-09'],
						data: this.lineChartsXData,
						axisPointer: {
							// type: 'shadow'
						}
					}],
					yAxis: [{
							type: 'value',
							name: this.chartName,
							splitLine: {
								lineStyle: {
									type: 'dashed', //设置刻度线条为虚线
									width: 1,
									color: '#DFE6F2'
								},
								show: true,
							},
							// min: 0,
							// max: 30,
							// interval: 5,
							axisLabel: {
								formatter: '{value}'
								// formatter: '{value} 个'
							}
						},
					],
					series: [{
						name: this.chartName,
						type: 'line',
						// symbol: "none",
						itemStyle: {
							color: "#007FFF", // 数据颜色
							gradientColorNum: 1,
						},
						// yAxisIndex: 1,
						tooltip: {
							valueFormatter: function(value) {
								return value;
								// return value + ' 个';
							}
						},
						// data: [0, 15, 17, 10, 25, 15, 20],
						data: this.lineChartsYDataChecked,
						smooth: 0.5,
						areaStyle: {
						  color: {
						    x: 0,
						    y: 0,
						    x2: 0,
						    y2: 1,
						    colorStops: [
						      {
						        offset: 0,
						        color: "rgba(0,127,255,0.1)", // 0% 处的颜色
						      },
						      {
						        offset: 1,
						        color: "rgba(255,255,255,0.1)", // 0% 处的颜色
						      },
						    ],
						  },
						},
					}]
				}
				option && myChart.setOption(option);
			},
			async getChartData() {
				let data = {
					startDate: '',
					endDate: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startDate = this.datePicker[0];
					data.endDate = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if(data.companyId && data.companyId == -1){
					data.companyId = ''
				}
				let res = await this.$http.post(this.$api.common.homeChartsData, data);
				this.lineChartsXData = []
				this.lineChartsYData1 = []
				this.lineChartsYData2 = []
				this.lineChartsYData3 = []
				this.lineChartsYData4 = []
				if (res.data && res.data.length > 0) {
					res.data.forEach(item => {
						this.lineChartsXData.push(item.recordTime);
						this.lineChartsYData1.push(item.income);
						this.lineChartsYData2.push(item.showNum);
						this.lineChartsYData3.push(item.clickNum);
						this.lineChartsYData4.push(item.ecpm);
					});
				}
				this.lineChartsYDataChecked = JSON.parse(JSON.stringify(this.lineChartsYData1));
				this.drawLineCharts();
			},
			dateChange(){
				this.getChartData();
			},
		},
	}
</script>

<style scoped>
	.mainPage {
		box-sizing: border-box;
		padding: 10px;
	}

	.mainBoxTop {
		background: #ffffff;
		align-items: center;
		height: 80px;
		padding: 0 24px;
		box-sizing: border-box;
	}

	.welcomeTxt {
		height: 28px;
		line-height: 28px;
		border-left: 3px solid #007FFF;
		padding-left: 12px;
		color: #333333;
		font-weight: 600;
		font-size: 20px;
	}

	.rightStatistics {
		width: 50%;
		margin-left: auto;
		height: 100%;
		align-items: center;
	}

	.statisticsBox {
		align-items: center;
		width: 33%;
		cursor: pointer;
	}

	.statisticsBox img {
		width: 48px;
		height: 48px;
		margin-right: 16px;
	}

	.statisticsTxt {
		color: #666666;
		font-weight: 600;
		font-size: 12px;
	}

	.statisticsNum {
		font-weight: 600;
		font-size: 24px;
		color: #333333;
	}

	.splitLine {
		width: 1px;
		height: 40px;
		background: #D9D9D9;
		margin-left: auto;
		margin-right: 32px;
	}

	.incomeList {
		margin-top: 10px;
	}

	.incomeBox {
		background: #ffffff;
		height: 120px;
		width: 24.6%;
		padding: 18px;
		padding-left: 24px;
		box-sizing: border-box;
	}

	.incomeBox>img {
		width: 40px;
		height: 40px;
	}

	.incomeCont {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.incomeTxt {
		font-weight: 600;
		font-size: 16px;
		color: rgba(51, 51, 51, 0.8);
	}

	.incomeNum {
		font-weight: 600;
		font-size: 24px;
		color: #333333;
		margin-top: 14px;
	}

	.chartsBox {
		background: #ffffff;
		margin-top: 10px;
	}

	.chartsRow {
		height: 63px;
		border-bottom: 1px solid #DFE2E7;
		padding: 0 24px;
		box-sizing: border-box;
		align-items: center;
		gap: 24px;
	}

	.chartPrimary,
	.chartControls {
		align-items: center;
		min-width: 0;
	}

	.chartControls {
		margin-left: auto;
	}

	.chartsTips {
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		margin-right: 16px;
		white-space: nowrap;
	}

	.homeCompanySelect {
		width: 210px;
	}

	.homeDataType {
		white-space: nowrap;
	}

	.homeDatePicker {
		margin-left: 15px;
	}

	#lineChart {
		height: 550px;
	}
	
	/deep/.el-radio input[aria-hidden="true"] {
	  display: none !important;
	}
	
	/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
	  box-shadow: none !important;
	}

	/* 平板端重排首页信息区，充分利用横向空间并避免控件相互遮盖 */
	@media screen and (max-width: 1024px) {
		.mainBoxTop {
			gap: 24px;
			padding: 0 20px;
		}

		.welcomeTxt {
			flex: 1;
			font-size: 18px;
			min-width: 140px;
			white-space: nowrap;
		}

		.rightStatistics {
			flex: 0 0 auto;
			gap: 16px;
			width: auto;
		}

		.statisticsBox {
			flex: 0 0 auto;
			width: auto;
		}

		.statisticsBox img {
			height: 40px;
			margin-right: 10px;
			width: 40px;
		}

		.statisticsNum {
			font-size: 20px;
		}

		.statisticsTxt {
			font-size: 11px;
			white-space: nowrap;
		}

		.splitLine {
			height: 36px;
			margin-left: 20px;
			margin-right: 0;
		}

		.incomeList {
			display: grid;
			gap: 10px;
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.incomeBox {
			height: 96px;
			padding: 14px 20px;
			width: 100%;
		}

		.incomeBox>img {
			height: 36px;
			width: 36px;
		}

		.incomeTxt {
			font-size: 14px;
		}

		.incomeNum {
			font-size: 18px;
			margin-top: 10px;
			overflow-wrap: anywhere;
		}

		.chartsRow {
			align-items: stretch;
			flex-direction: column;
			gap: 12px;
			height: auto;
			padding: 14px 20px;
		}

		.chartPrimary,
		.chartControls {
			width: 100%;
		}

		.chartControls {
			justify-content: space-between;
			margin-left: 0;
		}

		.homeDataType {
			display: grid;
			gap: 16px;
			grid-template-columns: repeat(4, auto);
		}

		/deep/ .homeDataType .el-radio {
			margin-right: 0;
		}

		.homeDatePicker {
			flex: 0 0 auto;
			margin-left: 16px;
		}
	}

	/* 首页移动端布局：各信息区域纵向展开，避免内容在窄屏中相互挤压 */
	@media screen and (max-width: 768px) {
		.mainPage {
			padding: 8px;
		}

		.mainBoxTop {
			align-items: stretch;
			flex-direction: column;
			gap: 0;
			height: auto;
			padding: 18px 16px 10px;
		}

		.welcomeTxt {
			font-size: 18px;
		}

		.rightStatistics {
			align-items: stretch;
			flex-direction: column;
			height: auto;
			margin-left: 0;
			margin-top: 10px;
			width: 100%;
		}

		.statisticsBox {
			box-sizing: border-box;
			min-height: 68px;
			padding: 10px 4px;
			width: 100%;
		}

		.statisticsBox:not(:last-child) {
			border-bottom: 1px solid #F0F0F0;
		}

		.statisticsBox img {
			margin-right: 14px;
		}

		.statisticsNum {
			font-size: 18px;
		}

		.splitLine {
			display: none;
		}

		.incomeList {
			display: grid;
			gap: 8px;
			grid-template-columns: minmax(0, 1fr);
		}

		.incomeBox {
			height: 108px;
			padding: 16px 20px;
			width: 100%;
		}

		.incomeNum {
			font-size: 18px;
			margin-top: 10px;
			overflow-wrap: anywhere;
		}

		.incomeTxt {
			font-size: 14px;
		}

		.chartsRow {
			align-items: stretch;
			gap: 12px;
			padding: 16px;
		}

		.chartPrimary,
		.chartControls {
			align-items: stretch;
			flex-direction: column;
			gap: 12px;
		}

		.chartsTips {
			margin-right: 0;
		}

		.homeCompanySelect {
			width: 100% !important;
		}

		.homeDataType {
			gap: 12px 8px;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			width: 100%;
		}

		/deep/ .homeDataType .el-radio {
			margin-right: 0;
		}

		/deep/ .homeDatePicker.el-date-editor.el-input__inner {
			margin-left: 0;
			width: 100% !important;
		}

		#lineChart {
			height: 400px;
			width: 100%;
		}
	}

	/* 超窄屏进一步压缩留白，为图表和表单保留展示空间 */
	@media screen and (max-width: 480px) {
		.mainPage {
			padding: 6px;
		}

		.mainBoxTop {
			padding-left: 12px;
			padding-right: 12px;
		}

		.incomeBox,
		.chartsRow {
			padding-left: 12px;
			padding-right: 12px;
		}

		.statisticsNum,
		.incomeNum {
			font-size: 16px;
		}

		.incomeTxt {
			font-size: 13px;
		}

		#lineChart {
			height: 360px;
		}
	}
</style>
